import apiClient from "@/services/apiClient";

export default {
    data() {
        return {
            timecardApiUrl: process.env.VUE_APP_TIMECARD_API_URL
        }
    },
    methods: {
        async toggleClock() {
            const {data} = await apiClient.post(`${this.timecardApiUrl}/entries`, {});

            return data;
        },
        async getEntries(start, end, username = '') {
            const {data} = await apiClient.get(`${this.timecardApiUrl}/entries/range/${start}/${end}/${username}`);

            return data;
        },
        async getTimecard() {
            const {data} = await apiClient.get(`${this.timecardApiUrl}/`);

            return data;
        },
        async getTotals(start, end) {
            const {data} = await apiClient.get(`${this.timecardApiUrl}/totals/${start}/${end}`);

            return data;
        },
        async getCurrent(username = '') {
            const {data} = await apiClient.get(`${this.timecardApiUrl}/entries/current/${username}`);

            return data;
        },
        async getRanges() {
            const {data} = await apiClient.get(`${this.timecardApiUrl}/ranges`);

            return data;
        },
        async getPaidTimeOff() {
            const {data} = await apiClient.get(`${this.timecardApiUrl}/paid-time/available`);

            return data;
        },
        async getPaidTimeOffLog() {
            const {data} = await apiClient.get(`${this.timecardApiUrl}/paid-time`);

            return data;
        },
        async getPaidTimeOffEmployees() {
            const {data} = await apiClient.get(`${this.timecardApiUrl}/paid-time/manage`);

            return data;
        },
        async addEmployeePaidDay(payload) {
            const {data} = await apiClient.post(`${this.timecardApiUrl}/paid-time/holiday`, payload);

            return data;
        },
        async createPaidTimeOffEmployee(username, available) {
            let payload = {
                available: available,
            };

            const {data} = await apiClient.post(`${this.timecardApiUrl}/paid-time/manage/${username}`, payload);

            return data;
        },
        async deletePaidTimeOffEmployee(username) {
            const {data} = await apiClient.delete(`${this.timecardApiUrl}/paid-time/manage/${username}`);

            return data;
        },
        async updatePaidTimeOffEmployee(username, available) {
            let payload = {
                available: available,
            };

            const {data} = await apiClient.patch(`${this.timecardApiUrl}/paid-time/manage/${username}`, payload);

            return data;
        },
        async getPaidTimeOffForPayPeriod(start, end) {
            const {data} = await apiClient.get(`${this.timecardApiUrl}/paid-time/range/${start}/${end}`);

            return data;
        },
        async getPaidTimeOffForPayPeriodUser(start, end, username) {
            const {data} = await apiClient.get(`${this.timecardApiUrl}/paid-time/manage/range/${start}/${end}/${username}`);

            return data;
        },
        async usePaidTimeOff(date, reason) {
            const payload = {
                date: date,
                reason: reason
            };

            const {data} = await apiClient.post(`${this.timecardApiUrl}/paid-time`, payload);

            return data;
        },
        async createRange(start, end) {
            const payload = {
                start: start,
                end: end,
            };

            const {data} = await apiClient.post(`${this.timecardApiUrl}/ranges`, payload);

            return data;
        },
        async updateRange(id, payload) {
            const {data} = await apiClient.patch(`${this.timecardApiUrl}/ranges/${id}`, payload);

            return data;
        },
        async updateEntry(id, payload) {
            const {data} = await apiClient.patch(`${this.timecardApiUrl}/entries/${id}`, payload);

            return data;
        }
    }
};